import { INaeViewSettings } from "@newageerp/nae-react-ui/dist/interfaces";

export const NaeViewFields: INaeViewSettings[] = [];